import * as React from "react";
import * as styles from "./QuickJournalDuneSunlightSlits.css";

export function QuickJournalDuneSunlightSlits({
    isPaused = false,
}: {
    isPaused?: boolean;
}) {
    const animationPlayState: React.CSSProperties["animationPlayState"] =
        isPaused ? "paused" : "running";

    return (
        <div aria-hidden="true" className={styles.container}>
            <span
                className={`${styles.beam} ${styles.beamOne}`}
                style={{ animationPlayState }}
            />
            <span
                className={`${styles.beam} ${styles.beamTwo}`}
                style={{ animationPlayState }}
            />
            <span
                className={`${styles.beam} ${styles.beamThree}`}
                style={{ animationPlayState }}
            />
        </div>
    );
}
